"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const styles = (theme) => (0, styles_1.createStyles)({
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10000,
        backgroundColor: color(theme.palette.common.white).alpha(0.37).rgb().string()
    },
    label: {
        color: theme.palette.text.secondary
    }
});
exports.default = styles;
//# sourceMappingURL=AppSpinnerStyle.js.map